module.exports = __webpack_public_path__ + "assets/icon_consulta.6868b4ef.svg";